import {ChangeDetectionStrategy, Component} from '@angular/core';
import { ObjectDetailSubjectsComponent } from '../../../document-shared/components/object-detail-subjects/object-detail-subjects.component';


@Component({
  selector: 'icz-file-detail-subjects',
  templateUrl: './file-detail-subjects.component.html',
  styleUrls: ['./file-detail-subjects.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ObjectDetailSubjectsComponent]
})
export class FileDetailSubjectsComponent  {

}
